<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit1"><a id="page_iii"></a>THE</h1>
<h1 class="tit2">SALVATION</h1>
<h1 class="tit2">ARMY</h1>
<p class="stit">150 YEARS OF BLOOD AND FIRE</p>
<p class="author">STEPHEN HUGGINS</p>
<div class="img_container">
<img alt="Images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?d26001f4